var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 290,
    viewBox: "0 0 246 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_7624)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_666_7624",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 35,
    width: 112,
    height: 86
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.352 35.3137H134.352V120.314H245.352V35.3137Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_666_7624)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.454 103.969C140.703 113.648 150.436 119.898 161.268 119.898L161.255 119.911C165.571 119.911 169.888 118.878 173.716 116.905L181.44 112.941C181.105 112.565 180.756 112.151 180.398 111.699C177.969 108.63 175.184 103.83 173.957 96.9052C173.761 95.7987 174.488 94.7405 175.58 94.5415C176.672 94.343 177.716 95.079 177.912 96.1861C179.003 102.344 181.457 106.529 183.533 109.152C184.573 110.466 185.525 111.397 186.182 111.995C186.412 112.204 186.564 112.336 186.703 112.457C186.792 112.534 186.876 112.608 186.971 112.693L186.982 112.702C187.03 112.744 187.16 112.86 187.287 113.003C192.479 117.312 199.235 119.752 206.146 119.752C212.499 119.752 218.54 117.633 223.128 113.793C230.988 107.213 234.164 96.7525 231.599 87.1664C244.033 80.3209 248.865 64.8955 242.349 52.4095C237.788 43.6838 228.531 38.2551 218.2 38.2551C213.748 38.2551 209.323 39.3144 205.4 41.327L195.205 46.5703L192.123 43.5647C186.965 38.5332 179.838 35.6467 172.562 35.6467C166.182 35.6467 160.033 37.8447 155.255 41.8566C146.499 49.2052 143.648 60.857 147.626 71.0524C136.115 77.8449 131.201 91.9859 136.454 103.969Z",
    fill: "url(#paint0_linear_666_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.884 75.62C172.58 75.5986 173.928 73.4343 173.895 70.7857C173.863 68.1371 172.462 66.0073 170.767 66.0287C169.071 66.0501 167.723 68.2145 167.756 70.8631C167.788 73.5117 169.189 75.6414 170.884 75.62Z",
    fill: "#464444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.307 75.4267C188.002 75.4053 189.351 73.2409 189.318 70.5924C189.285 67.9438 187.885 65.814 186.189 65.8354C184.494 65.8567 183.146 68.0211 183.179 70.6697C183.211 73.3183 184.612 75.448 186.307 75.4267Z",
    fill: "#464444"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.694 48.4099C203.925 48.0385 205.084 47.469 206.253 46.848C208.352 45.7508 209.951 44.1693 211.354 42.3418C212.48 40.891 213.216 39.2402 213.758 37.4767C214.874 33.9282 214.459 30.4872 213.249 27.0418C213.084 26.6154 213.135 26.0139 213.313 25.5936C214.302 23.2437 215.518 20.9595 216.409 18.566C217.137 16.6487 217.647 14.6142 217.38 12.4721C217.182 11.0053 216.578 9.734 215.535 8.70517C213.791 6.97181 211.644 5.88523 209.37 5.06874C207.024 4.21316 204.586 3.58058 202.121 3.26163C199.342 2.91513 196.537 2.56417 193.724 2.87512C191.638 3.12566 189.628 3.54858 187.85 4.78086C186.586 5.65064 185.896 6.88469 185.479 8.37817C184.562 11.6956 184.78 15.0495 185.131 18.3998C185.225 19.2385 185.324 20.0515 185.422 20.8644C185.504 21.6213 184.99 22.1429 184.557 22.652C183.271 24.2609 182.282 26.0005 181.677 27.9658C180.369 32.1708 180.836 36.231 182.796 40.0975C183.88 42.2742 185.542 44.02 187.399 45.5606C187.451 45.5695 187.506 45.5526 187.528 45.5828C189.279 46.8133 191.327 47.246 193.349 47.6742C195.169 48.0412 197.033 48.3095 198.889 48.4703C200.144 48.5805 201.447 48.4072 202.733 48.337L202.694 48.4099ZM201.954 8.53901C202.971 8.794 203.946 8.98857 204.881 9.25599C206.22 9.64602 207.585 10.0405 208.906 10.5335C209.849 10.9085 210.762 11.4638 211.289 12.4037C211.834 13.3997 211.687 14.409 211.345 15.4645C210.838 17.0219 210.053 18.3457 208.839 19.3834C208.152 19.9813 207.757 19.9662 206.973 19.4331C206.592 19.1817 206.185 18.9258 205.774 18.6957C203.31 17.2893 200.601 16.6896 197.825 16.6354C196.239 16.6007 194.655 17.0174 193.09 17.172C192.793 17.2004 192.406 17.1338 192.201 16.9392C191.367 16.2383 191.028 15.2778 190.832 14.2623C190.682 13.4405 190.566 12.5716 190.605 11.7294C190.661 10.3327 191.063 9.07562 192.545 8.48213C193.966 7.9313 195.432 7.89221 196.906 7.96063C198.617 8.04325 199.154 8.19212 200.795 8.36892L201.954 8.53901ZM200.008 19.824C200.008 19.824 200.116 19.657 200.155 19.5842C201.601 20.1252 203.116 20.5721 204.518 21.2118C207.296 22.4867 209.296 24.5826 210.509 27.3919C211.286 29.1972 211.516 31.094 211.634 33.0246C211.658 33.3471 211.472 33.6599 211.367 33.9602C211.289 33.9468 211.208 33.9593 211.126 33.9717C209.399 27.678 205.945 22.7844 199.982 19.8196L200.008 19.824Z",
    fill: "#66A3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_666_7624",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 135,
    width: 124,
    height: 94
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.32 135.314H1.32031V228.314H124.32V135.314Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_666_7624)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64949 210.431C8.3577 221.021 19.1429 227.859 31.1465 227.859L31.1315 227.873C35.9149 227.873 40.6983 226.743 44.9402 224.585L53.4988 220.248C53.128 219.836 52.7408 219.383 52.3443 218.889C49.6524 215.531 46.5665 210.279 45.2073 202.703C44.9901 201.492 45.7951 200.334 47.0052 200.117C48.2154 199.899 49.3726 200.705 49.5898 201.916C50.7984 208.653 53.518 213.232 55.8177 216.101C56.9703 217.539 58.0261 218.558 58.7541 219.212C59.0084 219.441 59.1765 219.585 59.3312 219.718C59.4297 219.802 59.5227 219.883 59.6284 219.976L59.6401 219.986C59.693 220.032 59.8371 220.159 59.9785 220.315C65.7317 225.029 73.218 227.7 80.8757 227.7C87.9157 227.7 94.6094 225.381 99.6936 221.18C108.404 213.98 111.923 202.536 109.08 192.047C122.859 184.557 128.214 167.68 120.994 154.019C115.939 144.472 105.681 138.533 94.2332 138.533C89.2993 138.533 84.396 139.692 80.0487 141.894L68.7521 147.63L65.3371 144.342C59.6212 138.837 51.7242 135.679 43.6616 135.679C36.5918 135.679 29.7777 138.083 24.4829 142.473C14.7807 150.513 11.6218 163.262 16.0292 174.417C3.27344 181.848 -2.17182 197.32 3.64949 210.431Z",
    fill: "url(#paint1_linear_666_7624)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1403 181.814C45.3533 181.814 48.7686 178.317 48.7686 174.002C48.7686 169.687 45.3533 166.19 41.1403 166.19C36.9273 166.19 33.512 169.687 33.512 174.002C33.512 178.317 36.9273 181.814 41.1403 181.814Z",
    fill: "#010938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2402 181.814C62.4532 181.814 65.8685 178.317 65.8685 174.002C65.8685 169.687 62.4532 166.19 58.2402 166.19C54.0271 166.19 50.6118 169.687 50.6118 174.002C50.6118 178.317 54.0271 181.814 58.2402 181.814Z",
    fill: "#010938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4121 174.003H36.2644",
    stroke: "#010938",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0671 174.003H123.165",
    stroke: "#010938",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6301 174.003H62.4824",
    stroke: "#010938",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6283 167.718C41.6283 167.718 34.0521 168.286 35.3801 175.995L41.6283 167.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1178 167.718C59.1178 167.718 51.5416 168.286 52.8696 175.995L59.1178 167.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9302 146.837C46.028 124.441 20.7291 139.075 15.7112 154.801H121.407C107.744 129.963 81.7128 138.809 67.9302 146.837Z",
    fill: "url(#paint2_linear_666_7624)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8203 288.314C96.7858 288.314 124.32 283.165 124.32 276.814C124.32 270.462 96.7858 265.314 62.8203 265.314C28.8548 265.314 1.32031 270.462 1.32031 276.814C1.32031 283.165 28.8548 288.314 62.8203 288.314Z",
    fill: "url(#paint3_linear_666_7624)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.852 255.486C220.503 255.486 245.352 250.959 245.352 245.375C245.352 239.79 220.503 235.263 189.852 235.263C159.2 235.263 134.352 239.79 134.352 245.375C134.352 250.959 159.2 255.486 189.852 255.486Z",
    fill: "url(#paint4_linear_666_7624)",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.822 189.581L152.833 155.066C150.312 151.438 145.326 150.541 141.698 153.063L125.312 164.451C121.684 166.973 120.787 171.958 123.309 175.586L147.297 210.101C149.819 213.729 154.804 214.626 158.432 212.105L174.818 200.716C178.447 198.194 179.343 193.209 176.822 189.581Z",
    fill: "url(#paint5_linear_666_7624)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.861 157.089L130.69 160.666L163.732 208.436L168.903 204.86L135.861 157.089Z",
    fill: "url(#paint6_linear_666_7624)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_7624",
    x1: 206.052,
    y1: 91.3673,
    x2: 162.946,
    y2: 50.2285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFA589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#FFA68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB59D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_666_7624",
    x1: 77.0305,
    y1: 207.322,
    x2: 30.3315,
    y2: 151.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5599FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730681,
    stopColor: "#A4C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_666_7624",
    x1: 68.5588,
    y1: 135.365,
    x2: 15.7142,
    y2: 145.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_666_7624",
    x1: 62.8203,
    y1: 260.187,
    x2: 62.8203,
    y2: 290.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECF1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_666_7624",
    x1: 189.852,
    y1: 230.756,
    x2: 189.852,
    y2: 257.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECF1",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_666_7624",
    x1: 152.739,
    y1: 142.124,
    x2: 165.345,
    y2: 212.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_666_7624",
    x1: 133.275,
    y1: 158.877,
    x2: 166.318,
    y2: 206.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_7624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245,
    height: 289,
    fill: "white",
    transform: "translate(0.662598 0.174805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/로그인그래픽2.993a3b2d6b1c5f48a169b562de7e90f5.svg";
export { ForwardRef as ReactComponent };